'use client';
import { lazy, Suspense, forwardRef, useRef, type ComponentProps, type ComponentRef } from 'react';
export type * from "/tmp/build-378/node_modules/@eliadmin/core/src/components/ui/multi-select.tsx";

type Props = NonNullable<ComponentProps<typeof import("/tmp/build-378/node_modules/@eliadmin/core/src/components/ui/multi-select.tsx").MultiSelect>>;
const Deferred = lazy(() => import("@eliadmin/module-original/multiSelect").then(m => ({ default: m.MultiSelect })));
export const MultiSelect = forwardRef<ComponentRef<typeof import("/tmp/build-378/node_modules/@eliadmin/core/src/components/ui/multi-select.tsx").MultiSelect>, Props>((props, ref) => <Suspense fallback={null}><Deferred {...props} ref={ref} /></Suspense>);
MultiSelect.displayName = "MultiSelect";

